import { useSignUp } from "@clerk/clerk-expo";
import { OAuthStrategy } from "@clerk/types";
import { Box, Button, HStack, Image, Spinner, Text } from "components/ui";
import React, { useState } from "react";
import facebookLogo from "../../assets/social-icons/facebook.png";
import googleLogo from "../../assets/social-icons/google.png";
import hubspotLogo from "../../assets/social-icons/hubspot.png";
import linkedinLogo from "../../assets/social-icons/linkedin.png";
import microsoftLogo from "../../assets/social-icons/microsoft.png";
import xeroLogo from "../../assets/social-icons/xero.svg";

interface ProviderConfig {
	strategy: OAuthStrategy;
	name: string;
	image: any;
	color: string;
}

const providers: ProviderConfig[] = [
	{
		strategy: "oauth_facebook",
		name: "Facebook",
		image: facebookLogo,
		color: "#1877F2",
	},
	{
		strategy: "oauth_google",
		name: "Google",
		image: googleLogo,
		color: "#4285F4",
	},
	{
		strategy: "oauth_hubspot",
		name: "Hubspot",
		image: hubspotLogo,
		color: "#333333",
	},
	{
		strategy: "oauth_linkedin",
		name: "LinkedIn",
		image: linkedinLogo,
		color: "#333333",
	},
	{
		strategy: "oauth_microsoft",
		name: "Microsoft",
		image: microsoftLogo,
		color: "#333333",
	},
	{
		strategy: "oauth_xero",
		name: "Xero",
		image: xeroLogo,
		color: "#333333",
	},
];

const OAuthSignUp = ({ layout = "grid", align = "center" }: { layout?: "grid" | "stack"; align?: "center" | "flex-start" }) => {
	const { signUp } = useSignUp();
	const [loadingStrategy, setLoadingStrategy] = useState<OAuthStrategy | null>(null);
	const [error, setError] = useState<string | null>(null);

	if (!signUp) return null;

	const handleOAuthSignUp = async (strategy: OAuthStrategy) => {
		try {
			setLoadingStrategy(strategy);
			setError(null);

			await signUp.authenticateWithRedirect({
				strategy,
				redirectUrl: "/sso-callback",
				redirectUrlComplete: "/",
			});
		} catch (err) {
			setError("Failed to initiate sign up. Please try again.");
			console.error("OAuth sign up error:", err);
		} finally {
			setLoadingStrategy(null);
		}
	};

	return (
		<Box width="$full">
			{/* Grid layout using flex */}
			<HStack justifyContent="space-evenly">
				{providers.map(({ strategy, name, image, color }) => (
					<Button key={strategy} variant="outline" bg="$basicwhite" onPress={() => handleOAuthSignUp(strategy)} justifyContent={align} sx={{ borderColor: "$neutral300", padding: 12 }}>
						{loadingStrategy === strategy ? (
							<Spinner color="$primarylight" />
						) : (
							<Box flexDirection="row" alignItems="center" gap="$2">
								<Image source={image} style={{ width: 20, height: 20 }} />
							</Box>
						)}
					</Button>
				))}
			</HStack>

			{error && (
				<Text color="$red500" fontSize="$sm" mt="$2">
					{error}
				</Text>
			)}
		</Box>
	);
};

export default OAuthSignUp;
